(function(){
'use strict';

function scPastDonorItem($window, scFlowModalService, scBanner) {
  var safeGet = function safeGet(obj, path) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return _.get(obj, path, defaultValue);
  };

  var showModal = function showModal(scope, title, message, iconClass) {
    if (!scFlowModalService || !scFlowModalService.open) return;
    scope.modalTitle = title;
    scope.modalMessage = message;
    scope.modalIconClass = iconClass;
    scFlowModalService.open({
      templateUrl: 'frs/shared/supporter/pages/donations/modals/pastDonors',
      maxWidth: 500,
      context: scope
    });
  };

  return {
    scope: {
      pastDonorItem: '=scPastDonorItem',
      theme: '=',
      block: '=',
      me: '='
    },
    templateUrl: 'global/directives/scPastDonorItem/template',
    link: function PastDonorItemController(scope) {
      scope.getDonorName = function getDonorName() {
        var d = scope.pastDonorItem || {};
        if (d._pastDonorName) {
          return d._pastDonorName || 'Anonymous';
        }
        var nickname = safeGet(d, 'nickname');
        var first = safeGet(d, 'first_name');
        var last = safeGet(d, 'last_name');
        var nameFromFields = [first, last].filter(Boolean).join(' ').trim();
        return nickname || nameFromFields || 'Anonymous';
      };

      scope.getFundraiserName = function getFundraiserName() {
        return safeGet(scope.pastDonorItem, 'title');
      };

      scope.getAmount = function getAmount() {
        var amount = safeGet(scope.pastDonorItem, 'amount');
        return amount ? '$' + amount : '';
      };

      scope.getEmail = function getEmail() {
        return safeGet(scope.pastDonorItem, 'email_address');
      };

      scope.copyEmail = function copyEmail() {
        var email = scope.getEmail();
        if (!email) return;

        var nav = $window && $window.navigator;
        var writeText = nav && nav.clipboard && nav.clipboard.writeText;
        if (!writeText) return;

        writeText(email).then(function () {
          showModal(scope, 'Email copied', 'Now paste them into your personal email', 'fa fa-envelope-o');
        }).catch(function () {
          scBanner('Failed to copy email to clipboard', 'error');
        });
      };

      scope.hasAlreadyDonated = function hasAlreadyDonated() {
        return !!safeGet(scope.pastDonorItem, 'donated_to_current', false);
      };
    }
  };
}

angular.module('classy').directive('scPastDonorItem', ['$window', 'scFlowModalService', 'scBanner', scPastDonorItem]);
})();